import { Grid, InputAdornment } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../../../app-context';
import IForm from '../../../components/i-form/i-form.component';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';
import { isNotNull, isEmpty } from '../../common/util.services';
import { getOrderById, saveOrder } from '../order.services';
import './order-form.component.scss';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import IDateField from '../../../components/text-component/i-datefield/i-datefield.component';
import LinkIcon from '@mui/icons-material/Link';
import dayjs from 'dayjs';
import { GridRowsProp } from '@mui/x-data-grid';
import ProductDetailPage from '../product/product-detail.component';
import { GET_SUPERVISOR_URL } from '../../common/constants';
import { Visibility } from '@mui/icons-material';

const OrderForm = (props: any) => {
  const [title, setTitle] = useState<string>('');
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const params = useParams()
  const rows: GridRowsProp = [];
  const [productDetail, setProductDetail] = useState(rows);
  const rowId = params.rowId;
  const [orderData, setOrderData] = useState<any>({});
  const [loader, setLoader] = useState(true);
  const {state} = useLocation();
  const [details, setDetails] = useState('');
  const detailsLink = "https://drive.google.com/drive/u/1/folders/1dysNXwhZFzxe_b-U32IGyWdswfDAh7xl";
  const {enquiryCode, customer, product, description, costingDate, products} = state;

  useEffect(() => {
    if (isNotNull(rowId)) {
      getOrderById(rowId, appContext,
        (response: any) => {
          setDetails(response.data.poDetails);
          setTitle('Edit Customer Order');
          response.data.orderDate = dayjs(response.data.orderDate);
          response.data.targetDate = dayjs(response.data.targetDate);
          setOrderData(response.data);
          setProductDetail(response.data.productDetail);
          setLoader(false);
          appContext.setShowLoader(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoader(false);
        });
    } else if (isNotNull(enquiryCode)) {
      setTitle('Add Customer Order');
      orderData.enquiryCode = enquiryCode;
      orderData.customer = customer;
      orderData.product = product;
      orderData.description = description;
      orderData.orderDate = dayjs();
      orderData.costingDate = costingDate;
      setProductDetail(products);
      appContext.setShowLoader(false);
      setLoader(false);
    } else {
      setLoader(false);
    }
  }, []);

  const validProductDetail = (data: any) => {
    let totalPOValue = 0;

    if(productDetail.length <= 0) {
      appContext.setDialogMessage('Add product details.');
      return false;
    }
    
    for(let i = 0; i < productDetail.length; ++i) {
      let row = productDetail[i];
      totalPOValue += +row.poValue;
      if (isEmpty(row.quantity) || isEmpty(row.poValue) || isEmpty(row.targetDate)) {
        appContext.setDialogMessage('Specify Quantity, PO Value and Target Date for all the rows.');
        return false;
      } else if (row.poValue <= 0) {
        appContext.setDialogMessage('Product PO Value should be greater than 0.');
        return false;
      }
      if(dayjs(dayjs(row.targetDate).format('YYYY-MM-DD')).isBefore(dayjs(dayjs(orderData.orderDate).format('YYYY-MM-DD')))) {
        appContext.setDialogMessage('Target date is before order date.');
        return false;
      }
    }

    if(totalPOValue !== +data) {
      appContext.setDialogMessage('Total PO value should be equal to sum of product PO values.');
      return false;
    }

    if(data <= 0) {
      appContext.setDialogMessage('Total PO value should be greater than 0.');
      return false;
    }

    return true;
  }

  const onSubmit = (data: any) => {
    let today = dayjs(dayjs().format('YYYY-MM-DD'));
    let ordDate = dayjs(dayjs(data.orderDate).format('YYYY-MM-DD'));
    let cosDate = dayjs(dayjs(data.costingDate).format('YYYY-MM-DD'));
    if(ordDate.isAfter(today)) {
      appContext.setDialogMessage('Future order date is not allowed.');
      return;
    } else if(ordDate.isBefore(cosDate)) {
      appContext.setDialogMessage('Order date is before a costing date.');
      return;
    }
    data.costingDate = null;

    if (validProductDetail(data.poValue)) {
      data.productDetail = productDetail;
      saveOrder(data, appContext,
        (response: any) => {
          navigate('/enquiry/order/enq/' + data.enquiryCode);
          appContext.setSuccessMessage(response.message)
          appContext.setShowLoader(false);
        }, (error: any) => {
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message)
        });
    }
  }
  const processRowUpdate = (updatedRow: any) => {}

  const onRowSelection = (selectedRows: any) => {
    setProductDetail(selectedRows);
  }

  const onRowDelete = (selectedRows: any) => {
    setProductDetail(selectedRows);
  }

  const getMainComponent = () => {
    return <Grid container spacing={1}>
      <Grid xs={2}>
        <ITextField name='code' label='Order Code' required={false} disabled={true} />
      </Grid>
      <Grid xs={2}>
        <ITextField name='enquiryCode' label='Enquiry Code' required={true} disabled={true} />
      </Grid>
      <Grid xs={2}>
        <ITextField name='customer' label='Customer' required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <IDropdown name='type' label='Type' required={true} itemList={['Sampling', 'Production']}/>
      </Grid>
      <Grid xs={2}>
        <IDropdown name='priority' label='Priority' required={true} itemList={['High', 'Medium', 'Low']}/>
      </Grid>
      <Grid xs={2}>
        <IDateField name='orderDate' label='Order Date'/>
      </Grid>
      <Grid xs={2}>
        <IDropdown name='projectManager' label='Supervisor' required={true} url={GET_SUPERVISOR_URL}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='referrence' label='Buyer Quote/Referrence' required={false}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='poDetails' label='PO Details' required={true}
          InputProps={{startAdornment: (<InputAdornment position="start"> <Link to={detailsLink} target="_blank"> <LinkIcon/> </Link> </InputAdornment>),
                       endAdornment: (<InputAdornment position="end"> <Link to={details} target="_blank"> <Visibility/> </Link> </InputAdornment>)}}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='poValue' label='Total PO Value' required={true} type='number'/>
      </Grid>
      <Grid xs={4}>
        <ITextField name='remarks' label='Remarks' required={false}/>
      </Grid>
      <Grid xs={12}>
        <ProductDetailPage onRowSelection={onRowSelection} enquiryCode={enquiryCode} orderId={rowId}
         productDetail={productDetail} onRowDelete={onRowDelete} processRowUpdate={processRowUpdate}/>
      </Grid>
    </Grid>
  }

  return loader ? <></> : <IForm formData={orderData} title={title} submitForm={onSubmit} mainComponent={getMainComponent()}></IForm>
}

export default OrderForm;